import { Box } from "@mui/material";
import { PURPLE_MAIN } from "./bentoTokens";

// Pill-style tab bar used by scenes/financial's sub-tabs, generalized for reuse.
// `tabs` is [{ key, label, badge? }]; `value` is the active index; `onChange(index)` fires on click.
const BentoTabs = ({ tabs, value, onChange, sx }) => (
  <Box
    sx={{
      display: "flex",
      gap: "4px",
      background: "#ece8f6",
      p: "4px",
      borderRadius: "11px",
      // Scroll horizontally on narrow screens instead of wrapping — no arrow
      // buttons, and the scrollbar is hidden so it never eats vertical space.
      flexWrap: "nowrap",
      maxWidth: "100%",
      overflowX: "auto",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": { display: "none" },
      ...sx,
    }}
  >
    {tabs.map((tabItem, index) => {
      const active = value === index;
      return (
        <Box
          key={tabItem.key ?? index}
          onClick={() => onChange(index)}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            userSelect: "none",
            flexShrink: 0,
            whiteSpace: "nowrap",
            fontSize: 13,
            fontWeight: active ? 700 : 600,
            color: active ? "#fff" : "#7c7787",
            background: active ? PURPLE_MAIN : "transparent",
            padding: "7px 18px",
            borderRadius: "8px",
            transition: "all .15s",
          }}
        >
          {tabItem.label}
          {!!tabItem.badge && (
            <Box
              sx={{
                fontSize: 11,
                fontWeight: 700,
                minWidth: 18,
                height: 18,
                px: "5px",
                borderRadius: "999px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: active ? "rgba(255,255,255,.25)" : "#f0b429",
                color: "#fff",
              }}
            >
              {tabItem.badge}
            </Box>
          )}
        </Box>
      );
    })}
  </Box>
);

export default BentoTabs;
